import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectWishlistItems } from '../../redux/selectors/wishlistSelector';
import { toggleWishlistItem } from '../../redux/slices/wishlistSlice';
import { addItemToCart } from '../../redux/slices/cartSlice';
import { setSelectedProduct } from '../../redux/slices/productSlice';
import { updatePrice } from '../../utils/helper';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';

const WishlistMain = () => {
  const products = useSelector(selectWishlistItems); // selector to get all products in wishlistItems
  const dispatch = useDispatch();

  // Dispatch the action the to get product details data
  const handleProductDetails = (product) => {
    dispatch(setSelectedProduct({ ...product, productId: product.id }));
  };

  // Dispatch the action to toggle the item to the wishlist with the adjusted price
  const handleToggleWishlist = (id, title) => {
    dispatch(toggleWishlistItem({ id: id, title: title }));
  };

  // Dispatch the action to add the item to cart
  const handleAddToCart = (product) => {
    dispatch(
      addItemToCart({
        product: product,
      })
    );
  };

  return (
    <main>
      <Breadcrumb title="Wishlist" />

      {products.length === 0 ? (
        <div className="it-error-content text-center pt-120 pb-100">
          <h5
            className="it-error-title wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            Your Wishlist is Empty
          </h5>
          <p
            className="mb-25 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            But it doesn't have to stay that way. <br /> Browse our collection
            and find something you love!
          </p>
          <Link
            className="it-btn-theme wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
            to="/shop-sidebar"
          >
            <Button btnText="Back To Shop" />
          </Link>
        </div>
      ) : (
        <section className="cart-area pt-120 pb-120">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <form action="#">
                  <div className="table-content table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="product-thumbnail">Images</th>
                          <th className="cart-product-name">Product</th>
                          <th className="product-price">Unit Price</th>
                          <th className="product-subtotal">Add To Cart</th>
                          <th className="product-remove">Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.map((product) => (
                          <tr key={product.id}>
                            <td className="product-thumbnail">
                              <Link
                                to={`/shop/${product.id}`}
                                onClick={() => handleProductDetails(product)}
                              >
                                <img src={product.thumbnail} alt="" />
                              </Link>
                            </td>
                            <td className="product-name">
                              <Link
                                to={`/shop/${product.id}`}
                                onClick={() => handleProductDetails(product)}
                              >
                                {product.title}
                              </Link>
                            </td>
                            <td className="product-price">
                              <span className="amount">
                                ${Math.round(updatePrice(product)).toFixed(2)}
                              </span>
                            </td>
                            <td className="product-subtotal">
                              <Link
                                to="#"
                                className="it-btn-theme text-white"
                                onClick={() => handleAddToCart(product)}
                              >
                                <Button btnText="Add To Cart" />
                              </Link>
                            </td>
                            <td className="product-remove">
                              <button
                                type="button"
                                onClick={() =>
                                  handleToggleWishlist(
                                    product.id,
                                    product.title
                                  )
                                }
                              >
                                <i className="fa fa-times"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </main>
  );
};

export default WishlistMain;
